import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'
import { BreadcrumbItem, BreadcrumbsWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'
import classNames from 'classnames'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import Breadcrumbs from '@src/quince-components/src/atoms/breadCrumb/BreadCrumb'
import Directory, { Path } from '@src/quince-site-common/src/domains/Directory'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { BreadcrumbsDSWidget } from './breadcrumbs-ds-widget'
import styles from './breadcrumbs.module.scss'

const BreadcrumbsWidgetComponent = (props: PLTypedWidgetProps<BreadcrumbsWidgetData>) => {
  if (shouldUseDesignSystem()) {
    return <BreadcrumbsDSWidget {...props} />
  }
  return <BreadcrumbsLegacyWidget {...props} />
}

const BreadcrumbsLegacyWidget = (props: PLTypedWidgetProps<BreadcrumbsWidgetData>) => {
  const { deviceType } = useDeviceInfo()
  const isMobile = deviceType === DEVICE_TYPES.MOBILE
  const isDesktop = deviceType === DEVICE_TYPES.DESKTOP
  const breadCrumbs = Array.isArray(props.data.breadCrumbsData?.breadCrumbs)
    ? props.data.breadCrumbsData.breadCrumbs
    : []
  const directory = new Directory({
    paths: breadCrumbs.map(
      (breadcrumb: BreadcrumbItem) =>
        new Path({
          displayName: breadcrumb.name,
          route: breadcrumb.slug,
        }),
    ),
  })
  const containerClass = classNames(styles.container, styles.new_clp_filters_experiment)

  return (
    <div>
      <div className={containerClass}>
        <div data-testid="collection-breadcrumb" className={isDesktop ? styles.container__text : ''}>
          <Breadcrumbs directory={directory} alignCenter={isMobile} deviceType={deviceType} />
        </div>
      </div>
    </div>
  )
}

export const BreadcrumbsWidget: PLTypedWidgetInterface<BreadcrumbsWidgetData, WidgetType.BREADCRUMBS> = {
  id: WidgetType.BREADCRUMBS,
  errorBoundary: PLBaseErrorBoundary,
  render: BreadcrumbsWidgetComponent,
}
